
import { Component, Vue } from "vue-property-decorator";

import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import {
    ChangScoreInputDto,
    OptionSettingsDto,
    ScoreScanSettingService,
    VipPaySettingService,
} from "@/api/service-proxies";
import Pagination from "@/components/Pagination/index.vue";
import { Row } from "element-ui";

class PageUserRequest extends PagedRequestDto {
    name!: string;
}

@Component({
    name: "User",
    components: {
        Pagination,
    },
})
export default class extends PagedListBase<PageUserRequest, OptionSettingsDto> {
    request = new PageUserRequest();
    payRecordVisible: boolean = false;
    changeVisible: boolean = false;

    private scoreService = new ScoreScanSettingService();

    created() {
        this.refresh();
    }

    getpage(finishCallback: Function): void {
        this.scoreService
            .getTenantScoreSettings(
                this.request.name,
                this.request.sorting,
                this.request.skipCount,
                this.request.maxResultCount
            )
            .then((result) => {
                console.log(result.items);
                this.list = result.items;
                this.showPaging(result);
                this.isTableLoading = false;
            });
    }

    search() {
        this.refresh();
    }

    //改变设置
    changeScanPermission(row) {
        var input = new ChangScoreInputDto();
        input.tenantId = row.tenantId;
        input.isScanVip = row.isVipScan;

        this.scoreService
            .changeTenantScoreSetting(input)
            .then((result) => {
                if (result) {
                  if(input.isScanVip){
                    this.$notify.success("小程序学生成绩已更新为仅会员可看");
                  }else{
                    this.$notify.success("小程序学生成绩已更新为全员可看");
                  }
                    
                } else {
                    this.$notify.warning("数据更新失败，请稍后重试");
                }
            });
    }
}
